import { ActorType } from "./ActorType";
import { v4 as uuidv4 } from 'uuid';

export class Actor
{
    id: string;
    sprite: Phaser.GameObjects.Sprite;
    collisionRectangle: Phaser.GameObjects.Rectangle;
    takeRectangle: Phaser.GameObjects.Rectangle;
    needsScaling: boolean = true;
    actorType: ActorType;
    attachedTo?: Actor | null;
    letter: string;
    letterPlant: Phaser.GameObjects.Text;
    lastUpdate: number = 0;
    group: number;
    order: number;
    realScale: number = 1.0;
    shadow: Phaser.GameObjects.Sprite;
    
    constructor() {
        this.id = uuidv4();
    }
}
